import React from 'react';
import { BaasicTableLoaderTemplate } from 'themes/components';

function BaasicTableLoader(props) {
    return (
        <BaasicTableLoaderTemplate {...props} />
    )
}

export default BaasicTableLoader;